var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArduinoNanoIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "241px",
    height: "95px",
    viewBox: "0 0 241 95",
    style: {
      enableBackground: "new 0 0 241 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F7391;}\r\n\t.st1{fill:none;stroke:#9A916C;stroke-width:1.1513;}\r\n\t.st2{fill:#CCCCCC;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#1A1A1A;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}\r\n\t.st6{opacity:0.2;}\r\n\t.st7{opacity:0.2;fill:#FFFFFF;}\r\n\t.st8{fill:#F2F2F2;}\r\n\t.st9{opacity:0.502;fill:#FFFFFF;}\r\n\t.st10{fill:#1A1A1A;}\r\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\r\n\t.st12{opacity:0.102;fill:#1A1A1A;}\r\n\t.st13{opacity:0.102;}\r\n\t.st14{fill:#666666;}\r\n\t.st15{fill:#999999;}\r\n\t.st16{fill:#B3B3B3;}\r\n\t.st17{fill:#333333;}\r\n\t.st18{fill:#E6E6E6;}\r\n\t.st19{fill:#404040;}\r\n\t.st20{fill:#8D8C8C;}\r\n\t.st21{fill:#8D8455;}\r\n\t.st22{fill:#8C8663;}\r\n\t.st23{fill:#B8AF82;}\r\n\t.st24{fill:#80795B;}\r\n\t.st25{fill:#5E5B43;}\r\n\t.st26{fill:#9A916C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st0",
    d: "M219.7,31.5c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4 C217.3,32.6,218.4,31.5,219.7,31.5L219.7,31.5z M233.3,31.5c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4 C230.9,32.6,232,31.5,233.3,31.5L233.3,31.5z M219.7,45.1c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4h0c-1.3,0-2.4-1.1-2.4-2.4 C217.3,46.2,218.4,45.1,219.7,45.1L219.7,45.1z M233.3,45.1c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4h0c-1.3,0-2.4-1.1-2.4-2.4 C230.9,46.2,232,45.1,233.3,45.1L233.3,45.1z M219.7,58.6c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4h0c-1.3,0-2.4-1.1-2.4-2.4 C217.3,59.7,218.4,58.6,219.7,58.6L219.7,58.6z M233.3,58.6c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4h0c-1.3,0-2.4-1.1-2.4-2.4 C230.9,59.7,232,58.6,233.3,58.6L233.3,58.6z M30.3,85.8c1.4,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4 C27.8,86.9,28.9,85.8,30.3,85.8L30.3,85.8z M43.9,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.4,0-2.4-1.1-2.4-2.4 C41.4,86.9,42.5,85.8,43.9,85.8C43.9,85.8,43.9,85.8,43.9,85.8z M57.4,85.8c1.4,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5 c0,0,0,0,0,0c-1.3,0-2.4-1.1-2.4-2.4C55,86.9,56.1,85.8,57.4,85.8L57.4,85.8z M71,85.8c1.3,0,2.4,1.1,2.4,2.4 c0,1.4-1.1,2.4-2.4,2.5c0,0,0,0,0,0c-1.3,0-2.4-1.1-2.4-2.4C68.6,86.9,69.7,85.8,71,85.8L71,85.8z M84.6,85.8 c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.4,0-2.4-1.1-2.4-2.4C82.1,86.9,83.2,85.8,84.6,85.8L84.6,85.8z M98.1,85.8 c1.4,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C95.7,86.9,96.8,85.8,98.1,85.8L98.1,85.8z M111.7,85.8 c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.4,0-2.4-1.1-2.4-2.4C109.3,86.9,110.4,85.8,111.7,85.8L111.7,85.8z M125.3,85.8 c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C122.8,86.9,123.9,85.8,125.3,85.8L125.3,85.8z M138.9,85.8 c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C136.4,86.9,137.5,85.8,138.9,85.8L138.9,85.8z M152.4,85.8 c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5c0,0,0,0,0,0c-1.3,0-2.4-1.1-2.4-2.4C150,86.9,151.1,85.8,152.4,85.8L152.4,85.8z  M166,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5c0,0,0,0,0,0c-1.3,0-2.4-1.1-2.4-2.4C163.6,86.9,164.7,85.8,166,85.8 L166,85.8z M179.6,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C177.1,86.9,178.2,85.8,179.6,85.8 L179.6,85.8z M193.1,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C190.7,86.9,191.8,85.8,193.1,85.8 L193.1,85.8z M206.7,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C204.3,86.9,205.4,85.8,206.7,85.8 L206.7,85.8z M220.3,85.8c1.3,0,2.4,1.1,2.4,2.4c0,1.4-1.1,2.4-2.4,2.5h0c-1.3,0-2.4-1.1-2.4-2.4C217.8,86.9,218.9,85.8,220.3,85.8 L220.3,85.8z M30.3,4.3c1.4,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C27.8,5.4,28.9,4.3,30.3,4.3z  M43.9,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.4,0-2.4-1.1-2.4-2.4C41.4,5.4,42.5,4.3,43.9,4.3z M57.4,4.3 c1.4,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C55,5.4,56.1,4.3,57.4,4.3z M71,4.3c1.3,0,2.4,1.1,2.4,2.4 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C68.6,5.4,69.7,4.3,71,4.3z M84.6,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.4,0-2.4-1.1-2.4-2.4C82.1,5.4,83.2,4.3,84.6,4.3z M98.1,4.3c1.4,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4C95.7,5.4,96.8,4.3,98.1,4.3z M111.7,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.4,0-2.4-1.1-2.4-2.4C109.3,5.4,110.4,4.3,111.7,4.3z M125.3,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4C122.8,5.4,123.9,4.3,125.3,4.3z M138.9,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4C136.4,5.4,137.5,4.3,138.9,4.3z M152.4,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4C150,5.4,151.1,4.3,152.4,4.3z M166,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4 C163.6,5.4,164.7,4.3,166,4.3z M179.6,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4 C177.1,5.4,178.2,4.3,179.6,4.3z M193.1,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4 C190.7,5.4,191.8,4.3,193.1,4.3z M206.7,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4 C204.3,5.4,205.4,4.3,206.7,4.3z M220.3,4.3c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4 C217.8,5.4,218.9,4.3,220.3,4.3z M233.9,2.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4h0c-2.4,0-4.4-2-4.4-4.4 C229.5,4.4,231.4,2.4,233.9,2.4L233.9,2.4z M233.9,83.8c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4 C229.5,85.8,231.4,83.8,233.9,83.8z M16.7,83.8c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4 C12.3,85.8,14.3,83.8,16.7,83.8z M16.7,2.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4h0c-2.4,0-4.4-2-4.4-4.4 C12.3,4.4,14.3,2.4,16.7,2.4z M9.9,0v95h230.7V0H9.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18080_",
    className: "st1",
    cx: 220.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18076_",
    className: "st1",
    cx: 206.7,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18074_",
    className: "st1",
    cx: 193.1,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18072_",
    className: "st1",
    cx: 179.6,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18070_",
    className: "st1",
    cx: 166,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18068_",
    className: "st1",
    cx: 152.4,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18066_",
    className: "st1",
    cx: 138.9,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18064_",
    className: "st1",
    cx: 125.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18062_",
    className: "st1",
    cx: 111.7,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18060_",
    className: "st1",
    cx: 98.1,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18058_",
    className: "st1",
    cx: 84.6,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18056_",
    className: "st1",
    cx: 71,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18054_",
    className: "st1",
    cx: 57.4,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18052_",
    className: "st1",
    cx: 43.9,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18050_",
    className: "st1",
    cx: 30.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18048_",
    className: "st1",
    cx: 220.3,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18046_",
    className: "st1",
    cx: 206.7,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18044_",
    className: "st1",
    cx: 193.1,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18042_",
    className: "st1",
    cx: 179.6,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18040_",
    className: "st1",
    cx: 166,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18038_",
    className: "st1",
    cx: 152.4,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18036_",
    className: "st1",
    cx: 138.9,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18034_",
    className: "st1",
    cx: 125.3,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18032_",
    className: "st1",
    cx: 111.7,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18030_",
    className: "st1",
    cx: 98.1,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18028_",
    className: "st1",
    cx: 84.6,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18026_",
    className: "st1",
    cx: 71,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18024_",
    className: "st1",
    cx: 57.4,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18022_",
    className: "st1",
    cx: 43.9,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18020_",
    className: "st1",
    cx: 30.3,
    cy: 88.2,
    r: 3.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_18004_",
    className: "st2",
    points: "145.8,51.7 145.5,51.7 145.5,43.3 145.8,43.3 145.8,37.1 133.9,37.1 133.9,57.9  145.8,57.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_18002_",
    className: "st2",
    points: "132,43.3 132.2,43.3 132.2,51.7 132,51.7 132,57.9 143.8,57.9 143.8,37.1  132,37.1  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18000_",
    className: "st3",
    cx: 138.9,
    cy: 47.5,
    r: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17998_",
    d: "M138.7,43.1c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4h0.2c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4 H138.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17996_",
    className: "st4",
    cx: 138.9,
    cy: 47.5,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17994_",
    className: "st5",
    cx: 139,
    cy: 47.5,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17992_",
    className: "st6",
    d: "M138.8,43.3c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2h0.2c-2.3,0-4.2-1.9-4.2-4.2 c0-2.3,1.9-4.2,4.2-4.2H138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17990_",
    className: "st7",
    d: "M138.8,51.7c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2h0.2c2.3,0,4.2,1.9,4.2,4.2 c0,2.3-1.9,4.2-4.2,4.2H138.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17982_",
    x: 132,
    y: 51.7,
    className: "st6",
    width: 0.3,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17980_",
    x: 132,
    y: 37.1,
    className: "st6",
    width: 0.3,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17978_",
    x: 132.3,
    y: 43.3,
    className: "st6",
    width: 0.3,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7052_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17976_",
    x: 161.1,
    y: 70.1,
    width: 17.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_17974_",
    x: 160.9,
    y: 71.3,
    className: "st8",
    width: 17.4,
    height: 9.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7048_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7341_",
    x: 161.1,
    y: 51.6,
    width: 17.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7340_",
    x: 160.9,
    y: 52.8,
    className: "st8",
    width: 17.4,
    height: 9.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7044_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7317_",
    x: 161.1,
    y: 33.1,
    width: 17.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7231_",
    x: 160.9,
    y: 34.3,
    className: "st8",
    width: 17.4,
    height: 9.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7056_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7072_",
    x: 164.8,
    y: 24.7,
    className: "st9",
    width: 10,
    height: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1639_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7139_",
    x: 161.1,
    y: 14.6,
    width: 17.2,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7135_",
    x: 160.9,
    y: 15.8,
    className: "st8",
    width: 17.4,
    height: 9.1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7040_",
    x: 74.5,
    y: 29.8,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 124.7571 146.6762)",
    className: "st10",
    width: 36.4,
    height: 35.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7036_",
    className: "st11",
    cx: 30.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7032_",
    className: "st7",
    d: "M29.6,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7028_",
    className: "st12",
    d: "M30.9,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H30.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7024_",
    x: 28.8,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7020_",
    x: 31.5,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7016_",
    x: 28.8,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_7012_",
    className: "st11",
    cx: 43.8,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7009_",
    className: "st7",
    d: "M43.2,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7004_",
    className: "st12",
    d: "M44.5,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.7c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H44.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7000_",
    x: 42.3,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6997_",
    x: 45.1,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6992_",
    x: 42.3,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6988_",
    className: "st11",
    cx: 57.4,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6984_",
    className: "st7",
    d: "M56.8,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6977_",
    className: "st12",
    d: "M58,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H58z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6973_",
    x: 55.9,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6969_",
    x: 58.7,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6965_",
    x: 55.9,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6961_",
    className: "st11",
    cx: 71,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6957_",
    className: "st7",
    d: "M70.4,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6H71c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6953_",
    className: "st12",
    d: "M71.6,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6H71c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H71.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6949_",
    x: 69.5,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6941_",
    x: 72.2,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6937_",
    x: 69.5,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6933_",
    className: "st11",
    cx: 84.5,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6929_",
    className: "st7",
    d: "M83.9,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6925_",
    className: "st12",
    d: "M85.2,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H85.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6522_",
    x: 83.1,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6518_",
    x: 85.8,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6498_",
    x: 83.1,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6462_",
    className: "st11",
    cx: 98.1,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6450_",
    className: "st7",
    d: "M97.5,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6442_",
    className: "st12",
    d: "M98.8,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H98.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6439_",
    x: 96.6,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6434_",
    x: 99.4,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6431_",
    x: 96.6,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6426_",
    className: "st11",
    cx: 111.7,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6422_",
    className: "st7",
    d: "M111.1,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6410_",
    className: "st12",
    d: "M112.3,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H112.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6406_",
    x: 110.2,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6402_",
    x: 113,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6389_",
    x: 110.2,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5740_",
    className: "st11",
    cx: 125.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5735_",
    className: "st7",
    d: "M124.6,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5732_",
    className: "st12",
    d: "M125.9,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H125.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5727_",
    x: 123.8,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5723_",
    x: 126.5,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5719_",
    x: 123.8,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5715_",
    className: "st11",
    cx: 138.8,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5711_",
    className: "st7",
    d: "M138.2,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5708_",
    className: "st12",
    d: "M139.5,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H139.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5703_",
    x: 137.3,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5699_",
    x: 140.1,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5696_",
    x: 137.3,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5691_",
    className: "st11",
    cx: 152.4,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5687_",
    className: "st7",
    d: "M151.8,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5684_",
    className: "st12",
    d: "M153,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H153z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5679_",
    x: 150.9,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5676_",
    x: 153.7,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5671_",
    x: 150.9,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5668_",
    className: "st11",
    cx: 166,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5663_",
    className: "st7",
    d: "M165.4,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5659_",
    className: "st12",
    d: "M166.6,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6H166c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H166.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5655_",
    x: 164.5,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5651_",
    x: 167.2,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5647_",
    x: 164.5,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5643_",
    className: "st11",
    cx: 179.5,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5640_",
    className: "st7",
    d: "M178.9,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5635_",
    className: "st12",
    d: "M180.2,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H180.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5631_",
    x: 178.1,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5628_",
    x: 180.8,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5623_",
    x: 178.1,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5619_",
    className: "st11",
    cx: 193.1,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5615_",
    className: "st7",
    d: "M192.5,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5611_",
    className: "st12",
    d: "M193.8,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H193.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5608_",
    x: 191.6,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5603_",
    x: 194.4,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5600_",
    x: 191.6,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5595_",
    className: "st11",
    cx: 206.7,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5592_",
    className: "st7",
    d: "M206.1,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5587_",
    className: "st12",
    d: "M207.3,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H207.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5583_",
    x: 205.2,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5579_",
    x: 208,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5575_",
    x: 205.2,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5570_",
    className: "st11",
    cx: 220.3,
    cy: 6.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5564_",
    className: "st7",
    d: "M219.6,10.4c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H219.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5558_",
    className: "st12",
    d: "M220.9,3.2c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 c0-2,1.6-3.6,3.6-3.6H220.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5554_",
    x: 218.8,
    y: 5.3,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5550_",
    x: 221.5,
    y: 5.3,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5508_",
    x: 218.8,
    y: 5.3,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5498_",
    className: "st11",
    cx: 30.3,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5493_",
    className: "st7",
    d: "M29.7,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5489_",
    className: "st12",
    d: "M31,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 H31z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5485_",
    x: 28.8,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5481_",
    x: 31.6,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5477_",
    x: 28.8,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5473_",
    className: "st11",
    cx: 43.9,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5465_",
    className: "st7",
    d: "M43.3,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5457_",
    className: "st12",
    d: "M44.5,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.7c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H44.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5439_",
    x: 42.4,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5431_",
    x: 45.2,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5423_",
    x: 42.4,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5415_",
    className: "st11",
    cx: 57.5,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5407_",
    className: "st7",
    d: "M56.8,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5399_",
    className: "st12",
    d: "M58.1,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H58.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5391_",
    x: 56,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5383_",
    x: 58.7,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5375_",
    x: 56,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5367_",
    className: "st11",
    cx: 71,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5359_",
    className: "st7",
    d: "M70.4,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6H71c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5351_",
    className: "st12",
    d: "M71.7,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6H71c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 H71.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5343_",
    x: 69.5,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5335_",
    x: 72.3,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5327_",
    x: 69.5,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5319_",
    className: "st11",
    cx: 84.6,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5311_",
    className: "st7",
    d: "M84,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4403_",
    className: "st12",
    d: "M85.3,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H85.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4385_",
    x: 83.1,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4371_",
    x: 85.9,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3814_",
    x: 83.1,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3438_",
    className: "st11",
    cx: 98.2,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3437_",
    className: "st7",
    d: "M97.6,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3436_",
    className: "st12",
    d: "M98.8,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H98.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3434_",
    x: 96.7,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3431_",
    x: 99.4,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3417_",
    x: 96.7,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3401_",
    className: "st11",
    cx: 111.7,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3393_",
    className: "st7",
    d: "M111.1,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3392_",
    className: "st12",
    d: "M112.4,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H112.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3390_",
    x: 110.3,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3210_",
    x: 113,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3001_",
    x: 110.3,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2991_",
    className: "st11",
    cx: 125.3,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2990_",
    className: "st7",
    d: "M124.7,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2978_",
    className: "st12",
    d: "M126,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 H126z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2942_",
    x: 123.8,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2876_",
    x: 126.6,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2867_",
    x: 123.8,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1750_",
    className: "st11",
    cx: 138.9,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1749_",
    className: "st7",
    d: "M138.3,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1748_",
    className: "st12",
    d: "M139.5,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H139.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1747_",
    x: 137.4,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1746_",
    x: 140.2,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1745_",
    x: 137.4,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1744_",
    className: "st11",
    cx: 152.5,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1743_",
    className: "st7",
    d: "M151.8,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1742_",
    className: "st12",
    d: "M153.1,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H153.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1741_",
    x: 151,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1740_",
    x: 153.7,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1738_",
    x: 151,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1687_",
    className: "st11",
    cx: 166,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1686_",
    className: "st7",
    d: "M165.4,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1684_",
    className: "st12",
    d: "M166.7,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6H166c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H166.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1681_",
    x: 164.5,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1680_",
    x: 167.3,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1679_",
    x: 164.5,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1677_",
    className: "st11",
    cx: 179.6,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1674_",
    className: "st7",
    d: "M179,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H179z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1662_",
    className: "st12",
    d: "M180.3,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H180.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1661_",
    x: 178.1,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1660_",
    x: 180.9,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1659_",
    x: 178.1,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1658_",
    className: "st11",
    cx: 193.2,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1657_",
    className: "st7",
    d: "M192.6,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1656_",
    className: "st12",
    d: "M193.8,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H193.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1654_",
    x: 191.7,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1653_",
    x: 194.4,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1652_",
    x: 191.7,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1651_",
    className: "st11",
    cx: 206.8,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1650_",
    className: "st7",
    d: "M206.1,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1649_",
    className: "st12",
    d: "M207.4,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6 s1.6-3.6,3.6-3.6H207.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1648_",
    x: 205.3,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1647_",
    x: 208,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1646_",
    x: 205.3,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1645_",
    className: "st11",
    cx: 220.3,
    cy: 88.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1644_",
    className: "st7",
    d: "M219.7,91.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6h0.6c2,0,3.6,1.6,3.6,3.6 c0,2-1.6,3.6-3.6,3.6H219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1643_",
    className: "st12",
    d: "M221,84.8c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h-0.6c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 H221z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1642_",
    x: 218.8,
    y: 86.8,
    className: "st2",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1641_",
    x: 221.6,
    y: 86.8,
    className: "st7",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1640_",
    x: 218.8,
    y: 86.8,
    className: "st13",
    width: 0.2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1637_",
    x: 11.7,
    y: 66.2,
    className: "st2",
    width: 13.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1636_",
    x: 41.2,
    y: 66.2,
    className: "st2",
    width: 13.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1635_",
    x: 11.7,
    y: 18.7,
    className: "st2",
    width: 13.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1634_",
    x: 11.7,
    y: 66.2,
    className: "st8",
    width: 0.3,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1633_",
    x: 11.7,
    y: 18.7,
    className: "st8",
    width: 0.3,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1631_",
    x: 24.9,
    y: 66.2,
    className: "st6",
    width: 0.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1630_",
    x: 24.9,
    y: 18.7,
    className: "st6",
    width: 0.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1629_",
    x: 41.2,
    y: 18.7,
    className: "st2",
    width: 13.5,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1628_",
    x: 41.2,
    y: 66.2,
    className: "st8",
    width: 0.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1627_",
    x: 41.2,
    y: 18.7,
    className: "st8",
    width: 0.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1626_",
    x: 48.5,
    y: 37.5,
    className: "st14",
    width: 5.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1624_",
    x: 48.9,
    y: 37.5,
    className: "st15",
    width: 5.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1623_",
    x: 48.5,
    y: 41.9,
    className: "st14",
    width: 5.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1622_",
    x: 48.9,
    y: 41.9,
    className: "st15",
    width: 5.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1621_",
    x: 48.5,
    y: 46.3,
    className: "st14",
    width: 5.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1620_",
    x: 48.9,
    y: 46.3,
    className: "st15",
    width: 5.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1619_",
    x: 48.5,
    y: 50.7,
    className: "st14",
    width: 5.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1618_",
    x: 48.9,
    y: 50.7,
    className: "st15",
    width: 5.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1617_",
    x: 48.5,
    y: 55.1,
    className: "st14",
    width: 5.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1616_",
    x: 48.9,
    y: 55.1,
    className: "st15",
    width: 5.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1615_",
    x: 1.3,
    y: 27.5,
    className: "st16",
    width: 47.9,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1614_",
    x: 48.9,
    y: 27.5,
    className: "st2",
    width: 0.3,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1613_",
    x: 4.3,
    y: 30.6,
    className: "st17",
    width: 44.9,
    height: 33.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1612_",
    className: "st2",
    d: "M47.9,27l1.2,0.5v5.4c0,0-0.2-4.9-0.6-5.1c-0.4-0.2-0.6,0.2-0.6,0.2L47.9,27L47.9,27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1611_",
    className: "st2",
    d: "M47.9,67.9l1.2-0.5v-5.4c0,0-0.2,4.9-0.6,5.1c-0.4,0.2-0.6-0.2-0.6-0.2L47.9,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st18",
    d: "M24.7,31c0.3,0,0.5,0.2,0.5,0.5v1.4c0,0.3-0.2,0.5-0.5,0.5H12.2c-0.3,0-0.5-0.2-0.5-0.5v-1.4 c0-0.3,0.2-0.5,0.5-0.5H24.7z M8.7,34.1l1.6,1.6c0.2,0.2,0.5,0.3,0.8,0.3h13.6c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5 H6.6c-0.3,0-0.5-0.2-0.5-0.5v-1.1c0-0.3,0.2-0.6,0.3-0.8l1.6-1.6C8.3,33.9,8.6,33.9,8.7,34.1z M42.2,34.1c0.3,0,0.5,0.2,0.5,0.5 v24.8c0,0.3-0.2,0.5-0.5,0.5h-1.6c-0.3,0-0.5-0.2-0.5-0.5V34.6c0-0.3,0.2-0.5,0.5-0.5H42.2z M8.1,60.4l-1.6-1.6 c-0.2-0.2-0.3-0.5-0.3-0.8v-1.1c0-0.3,0.2-0.5,0.5-0.5h18.2c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5H11.2 c-0.3,0-0.6,0.2-0.8,0.3l-1.6,1.6C8.6,60.6,8.3,60.6,8.1,60.4z M6.1,53.3v-0.3c0-0.3,0.2-0.5,0.5-0.5l18.7-1.1 c0.3,0,0.5-0.2,0.5-0.5V44c0-0.3-0.2-0.5-0.5-0.5L6.6,42.4c-0.3,0-0.5-0.2-0.5-0.5v-0.3c0-0.3,0.2-0.5,0.5-0.4l23.6,1.4 c0.3,0,0.5,0.2,0.5,0.5v8.9c0,0.3-0.2,0.5-0.5,0.5L6.6,53.7C6.3,53.7,6.1,53.5,6.1,53.3z M24.7,61.1c0.3,0,0.5,0.2,0.5,0.5v1.4 c0,0.3-0.2,0.5-0.5,0.5H12.2c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5H24.7z M1.3,67.9h47.8V56.3h-1.2V38.6h1.2V27H1.3 V67.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1572_",
    className: "st8",
    points: "1.3,27.9 1.3,27 49.2,27 49.2,30.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1571_",
    className: "st8",
    points: "1.3,67.9 36.3,66.7 49.2,65.5 49.2,67.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1570_",
    x: 1.3,
    y: 27,
    className: "st8",
    width: 0.7,
    height: 40.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1569_",
    className: "st8",
    points: "2,68.9 1.3,68.9 0.4,68.9 0.4,67.9 0.4,27 0.4,26.1 1.3,26.1 2,26.1 2,28 1.3,28  1.3,27 2.2,27 2.2,67.9 1.3,67.9 1.3,67 2,67  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1638_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18018_",
    className: "st1",
    cx: 229.4,
    cy: 60.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_18016_",
    x: 225.2,
    y: 56.7,
    className: "st1",
    width: 8.4,
    height: 8.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18014_",
    className: "st1",
    cx: 213.5,
    cy: 60.9,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18012_",
    className: "st1",
    cx: 229.4,
    cy: 45,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18010_",
    className: "st1",
    cx: 213.5,
    cy: 45,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18008_",
    className: "st1",
    cx: 229.4,
    cy: 29.2,
    r: 4.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_18006_",
    className: "st1",
    cx: 213.5,
    cy: 29.2,
    r: 4.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1568_",
    className: "st19",
    points: "209.1,68.5 217.8,68.5 225.1,68.5 233.8,68.5 237.1,65.2 237.1,56.5 233.8,53.2  225.1,53.2 217.8,53.2 209.1,53.2 205.7,56.5 205.7,65.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1567_",
    className: "st19",
    points: "209.1,52.7 217.8,52.7 225.1,52.7 233.8,52.7 237.1,49.4 237.1,40.7 233.8,37.4  225.1,37.4 217.8,37.4 209.1,37.4 205.7,40.7 205.7,49.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1566_",
    className: "st19",
    points: "209.1,36.9 217.8,36.9 225.1,36.9 233.8,36.9 237.1,33.5 237.1,24.9 233.8,21.5  225.1,21.5 217.8,21.5 209.1,21.5 205.7,24.9 205.7,33.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1565_",
    className: "st19",
    points: "209.1,68.5 217.8,68.5 225.1,68.5 233.8,68.5 237.1,65.2 237.1,56.5 233.8,53.2  225.1,53.2 217.8,53.2 209.1,53.2 205.7,56.5 205.7,65.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1552_",
    className: "st19",
    points: "209.1,52.7 217.8,52.7 225.1,52.7 233.8,52.7 237.1,49.4 237.1,40.7 233.8,37.4  225.1,37.4 217.8,37.4 209.1,37.4 205.7,40.7 205.7,49.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1551_",
    className: "st19",
    points: "209.1,36.9 217.8,36.9 225.1,36.9 233.8,36.9 237.1,33.5 237.1,24.9 233.8,21.5  225.1,21.5 217.8,21.5 209.1,21.5 205.7,24.9 205.7,33.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1548_",
    x: 226.7,
    y: 27,
    className: "st20",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1547_",
    x: 210.9,
    y: 27,
    className: "st20",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1544_",
    x: 226.7,
    y: 42.8,
    className: "st20",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1543_",
    x: 210.9,
    y: 42.8,
    className: "st20",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1542_",
    x: 226.7,
    y: 58.7,
    className: "st20",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1541_",
    x: 210.9,
    y: 58.7,
    className: "st21",
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1540_",
    x: 212.1,
    y: 59.9,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1539_",
    className: "st23",
    points: "215.9,63.8 214.7,62.5 212.1,62.5 210.9,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1538_",
    className: "st24",
    points: "212.1,59.9 212.1,62.5 210.9,63.8 210.9,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1537_",
    className: "st25",
    points: "214.7,59.9 212.1,59.9 210.9,58.7 215.9,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1536_",
    className: "st26",
    points: "215.9,63.8 214.7,62.5 214.7,59.9 215.9,58.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1535_",
    x: 228,
    y: 59.9,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1534_",
    className: "st23",
    points: "231.8,63.8 230.6,62.5 228,62.5 226.7,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1533_",
    className: "st24",
    points: "228,59.9 228,62.5 226.7,63.8 226.7,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1532_",
    className: "st25",
    points: "230.6,59.9 228,59.9 226.7,58.7 231.8,58.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1531_",
    className: "st26",
    points: "231.8,63.8 230.6,62.5 230.6,59.9 231.8,58.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1530_",
    x: 212.1,
    y: 44.1,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1529_",
    className: "st23",
    points: "215.9,47.9 214.7,46.7 212.1,46.7 210.9,47.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1528_",
    className: "st24",
    points: "212.1,44.1 212.1,46.7 210.9,47.9 210.9,42.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1527_",
    className: "st25",
    points: "214.7,44.1 212.1,44.1 210.9,42.8 215.9,42.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1526_",
    className: "st26",
    points: "215.9,47.9 214.7,46.7 214.7,44.1 215.9,42.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1525_",
    x: 228,
    y: 44.1,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1524_",
    className: "st23",
    points: "231.8,47.9 230.6,46.7 228,46.7 226.7,47.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1523_",
    className: "st24",
    points: "228,44.1 228,46.7 226.7,47.9 226.7,42.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1521_",
    className: "st25",
    points: "230.6,44.1 228,44.1 226.7,42.8 231.8,42.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1519_",
    className: "st26",
    points: "231.8,47.9 230.6,46.7 230.6,44.1 231.8,42.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1518_",
    x: 212.1,
    y: 28.2,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1517_",
    className: "st23",
    points: "215.9,32 214.7,30.8 212.1,30.8 210.9,32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1515_",
    className: "st24",
    points: "212.1,28.2 212.1,30.8 210.9,32 210.9,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1514_",
    className: "st25",
    points: "214.7,28.2 212.1,28.2 210.9,27 215.9,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1513_",
    className: "st26",
    points: "215.9,32 214.7,30.8 214.7,28.2 215.9,27  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1512_",
    x: 228,
    y: 28.2,
    className: "st22",
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1511_",
    className: "st23",
    points: "231.8,32 230.6,30.8 228,30.8 226.7,32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1510_",
    className: "st24",
    points: "228,28.2 228,30.8 226.7,32 226.7,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1508_",
    className: "st25",
    points: "230.6,28.2 228,28.2 226.7,27 231.8,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1502_",
    className: "st26",
    points: "231.8,32 230.6,30.8 230.6,28.2 231.8,27  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArduinoNanoIllustration);
export default __webpack_public_path__ + "static/media/icon-arduino-nano-illustration.aac120ec0b37a69558bba604e8dbde61.svg";
export { ForwardRef as ReactComponent };